module.exports = __webpack_public_path__ + "product/product-step-plain-aa5b065d00981af8e289772d33a7a0a9.svg";